export function isNotPlaceholder({ node }) {
  if (node.name) {
    return !node.name.match(/placeholder/i)
  }

  if (node.title) {
    return !node.title.match(/placeholder/i)
  }

  return true
}

export function replaceLinksWithNewTabLinks(content) {
  if (!content) {
    return
  }

  return content.replace(
    /<a href="(.*)" (.*)<\/a>/g,
    `<a href="$1" target="_blank" rel="noopener noreferrer" $2</a>`
  )
}
